import { Alert, Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';

export default function PageIndexView(props) {

    const [ary, setAry] = React.useState([]);
    const settingData = useSelector(state => state.settingData);

    React.useEffect(() => {
        if (props.totalCount > 0) {
            refreshIndex(props.currentIndex, props.totalCount);
            // refreshIndex(10, 20);
        }
    }, [props.totalCount, props.currentIndex]);

    function refreshIndex(i, pageCount) {
        let index = i + 1;
        let x = [];
        if (pageCount > 0) {
            x.push(1); //第一页

            if (index - 4 > 1) {
                x.push(-1); //...
            }

            addOffset(index, -3, x, pageCount);
            addOffset(index, -2, x, pageCount);
            addOffset(index, -1, x, pageCount);

            if (index != 1 && index != pageCount) {
                x.push(index); //当前页
            }

            addOffset(index, 1, x, pageCount);
            addOffset(index, 2, x, pageCount);
            addOffset(index, 3, x, pageCount);

            if (index + 4 < pageCount) {
                x.push(-1); //...
            }

            if (pageCount > 1) {
                x.push(pageCount); //最后一页
            }
        }
        setAry(x);
    }

    function addOffset(current, offset, ary, pageCount) {
        let i = current + offset;
        if (i > 0 && i != 1 && i != pageCount && i != current && i < pageCount) {
            ary.push(i);
        }
    }

    return (
        <Stack sx={{
            width: 1,
            pt: 3,
            pb: settingData.isMobile ? 1 : 5,
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
        }}>

            {ary.map((value, index) => {
                return <Item key={index} value={value} currentIndex={props.currentIndex} pageIndexTap={props.pageIndexTap} />
            })}

        </Stack>
    );
}

function Item(props) {
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack>
            {props.value > 0 &&
                <Typography
                    onClick={() => {
                        props.pageIndexTap(props.value - 1)
                    }}
                    sx={{
                        mx: settingData.isMobile ? 0.5 : 1,
                        bgcolor: 'red',
                        fontSize: settingData.isMobile ? 13 : 17,
                        fontWeight: 'bold',
                        bgcolor: props.currentIndex + 1 == props.value ? '#969696' : 'black',
                        color: 'white',
                        width: settingData.isMobile ? '24px' : '36px',
                        height: settingData.isMobile ? '24px' : '36px',
                        lineHeight: settingData.isMobile ? '24px' : '36px',
                        textAlign: 'center',
                        borderRadius: settingData.isMobile ? '12px' : '18px',
                        cursor: 'pointer',
                    }}>
                    {props.value}
                </Typography>
            }

            {props.value < 0 &&
                <Typography sx={{
                    height: '10px',
                    lineHeight: '10px',
                    fontSize: settingData.isMobile ? 20 : 30,
                    width: settingData.isMobile ? '24px' : '36px',
                    pb: settingData.isMobile ? 1 : 2,
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    ...
                </Typography>
            }

        </Stack>

    );
}

